import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import customColors from 'src/config/colorsV2'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  root: {
    cursor: 'pointer',
    wordBreak: 'break-word',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    '&:hover $radioInput': {
      boxShadow: '0px 0px 0px 4px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    '&$disabled': {
      opacity: 0.5,
      cursor: 'default',
      '&:hover $radioInput': {
        boxShadow: 'none',
        backgroundColor: 'transparent',
      },
    },

    '& .radioInput': {
      cursor: 'inherit',
      flexShrink: 0,
      position: 'relative',
      margin: 0,
      borderRadius: '50%',
      width: 20,
      height: 20,
      padding: 0,
      backgroundColor: 'transparent',
      border: `2px solid ${customColors['grey-700']}`,
      transition: 'box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out',
      '&:checked': {
        borderColor: theme.palette.primary.main,
        '&::before': {
          position: 'absolute',
          content: '""',
          top: 3,
          right: 3,
          bottom: 3,
          left: 3,
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
  },
  radioLabel: {
    paddingLeft: 8,
    cursor: 'inherit',
    ...typography['Lato Body 1'],
    color: theme.palette.grey['700'],
  },
  disabled: {},
}))
